function Response({ required }) {
	return (
        <span style={{color: 'red'}}>{(required) ? '*' : ''}</span>
	);
};

export default Response;